

























































import BaseComponent from '@/components/base/BaseComponent';
import { Component, Inject } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  FORM101_DATA,
  FORM_LOADING_MODE,
  OPEN_CONFIRM_FORM_DIALOG, SET_FORM_LOADING_MODE,
  SET_OPEN_CONFIRM_FORM_DIALOG, SET_SUBMIT_FORM_ERRORS,
  SUBMIT_FORM,
  SUBMIT_FORM_ERRORS,
} from '@/types/form.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Form101DataModel } from '@/models/form/Form101Data.model';

@Component({})
export default class WizardConfirmDialog extends BaseComponent {
  @Inject() public $validator: any;

  @Action(SUBMIT_FORM, StoreNamespace.FORM) public submitForm;

  @Mutation(SET_OPEN_CONFIRM_FORM_DIALOG, StoreNamespace.FORM) public setOpenConfirmFormDialog;
  @Mutation(SET_SUBMIT_FORM_ERRORS, StoreNamespace.FORM) public setSubmitFormErrors;
  @Mutation(SET_FORM_LOADING_MODE, StoreNamespace.FORM) public setFormLoadingMode;

  @Getter(OPEN_CONFIRM_FORM_DIALOG, StoreNamespace.FORM) public openConfirmFormDialog!: boolean;
  @Getter(FORM_LOADING_MODE, StoreNamespace.FORM) public formLoadingMode!: boolean;
  @Getter(SUBMIT_FORM_ERRORS, StoreNamespace.FORM) public submitFormErrors!: string[];
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;

  public password: string = '';

  public closeDialog() {
    this.setSubmitFormErrors([]);
    this.setOpenConfirmFormDialog(false);
  }

  public completeForm() {
    this.setFormLoadingMode(true);
    this.$validator.validateAll('payrollFormFinish').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
        this.setFormLoadingMode(false);
      } else {
        this.submitForm({
          password: this.password,
          effectiveDate: this.form101Data.effectiveDate ? this.form101Data.effectiveDate : null,
        });
      }
    });
  }
}
